import React from "react";

import { tw } from "@/utils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  icon?: React.ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ error, icon, ...inputProps }, ref) => {
    return (
      <div className="relative flex items-center">
        {icon && (
          <span className="absolute left-3 text-neutral-500">{icon}</span>
        )}
        <input
          ref={ref}
          {...inputProps}
          className={tw(
            "h-12 w-full rounded-lg border px-4 py-3 text-primary-950 shadow-sm placeholder:text-neutral-500",
            error ? "border-error-700" : "border-neutral-200",
            "hover:border-primary-200",
            "focus:border-primary-300 focus:shadow-focus focus:outline-none",
            icon && "pl-8",
          )}
        />
      </div>
    );
  },
);

Input.displayName = "Input";
